<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>广告变现收入</span>
    </div>
    <el-form :inline="true">
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="queryParams.startDate"
          placeholder="请选择日期"
          clearable
          value-format="yyyy-MM-dd"
          type="date"
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="queryParams.endDate"
          placeholder="请选择日期"
          clearable
          value-format="yyyy-MM-dd"
          type="date"
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="国家">
        <el-select v-model="queryParams.country" filterable placeholder="请选择">
          <el-option
            v-for="item in country"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery(false)">查询</el-button>
        <el-button type="success" :loading="loading" size="mini" @click="handleQuery(true)">导出</el-button>
      </el-form-item>
      <!--      <one-import :get-table="getTables" :import-method="importAdBill" />-->
    </el-form>

    <echartTemp
      ref="adStat"
      title="广告变现收入"
    />

    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :default-expand-all="false"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
      />
      <el-table-column
        prop="type"
        label="平台"
        align="center"
        :formatter="typeFormatter"
      />
      <el-table-column
        prop="country"
        label="国家"
        align="center"
      />
      <el-table-column
        prop="view"
        label="浏览数"
        align="center"
      />
      <el-table-column
        prop="click"
        label="请求数"
        align="center"
      />
      <!--      <el-table-column-->
      <!--        prop="click_rate"-->
      <!--        label="点击率"-->
      <!--        align="center"-->
      <!--        :formatter="differFormatter"-->
      <!--      />-->
      <el-table-column
        prop="price"
        label="金额"
        align="center"
        :formatter="priceFormatter"
      />
    </el-table>

  </el-card>
</template>

<script>
import { getAdBill } from '@/api/config/order'
import echartTemp from '@/components/Charts/Charts.vue'
import { dateStrTodate } from '@/utils'

export default {
  name: 'AdBillStat',
  components: {
    echartTemp
  },
  data() {
    return {
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        level: 0
      },
      total: 0,
      tableData: [],
      country: []
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleQuery(isExport) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
      }
      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
      }
      this.queryParams.level = 0
      if (isExport) {
        this.queryParams.level = 1
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      getAdBill(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          if (this.queryParams.level > 0) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }
          this.tableData = res.data.data
          const country = res.data.country
          this.country = [{ label: '全部', value: '' }]
          for (const i in country) {
            this.country.push({ label: country[i], value: i })
          }
          this.total = res.data.count
          this.queryParams.startDate = res.data.req.StartDate
          this.queryParams.endDate = res.data.req.EndDate
          // this.$refs.echart.change(this.tableData)
          this.initEChart(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    initEChart(data) {
      const obj = { legend: ['广告收入'], series: [], xAxis: [] }
      const temp = {
        name: '广告收入',
        data: [],
        type: 'line',
        smooth: true,
        label: {
          show: true,
          position: 'top', // 标签显示在折线图顶部
          formatter: '{c}' // 显示数值
        }
      }
      const echartData = []
      for (const i in data) {
        const val = data[i]
        echartData.push(val.price)
        obj.xAxis.push(dateStrTodate(val.date))
      }
      temp.data = echartData
      obj.series.push(temp)
      this.$refs.adStat.refresh(obj)
    },
    typeFormatter(row, col) {
      const typeMap = { 0: '所有', 1: '安卓', 2: '苹果' }
      return typeMap[row.type]
    },
    differFormatter(row, col, val) {
      return val + '%'
    },
    priceFormatter(row, col, val) {
      return '$' + val
    }
  }
}
</script>

<style scoped>

</style>
